export const formatPercent = (v: number | undefined) => {
  if (v === undefined) return undefined;
  return `${Math.floor(v * 10000) / 100}%`;
};
